(() => {
  const mockTrackingApp = {
    always(cb) {
      if (typeof cb === 'function') {
        cb();
      }
    },
    then(cb) {
      if (typeof cb === 'function') {
        cb();
      }
    },
  };

  const analyticsCache = {};

  function analyticsCacheAdd(productInformation) {
    productInformation.forEach((product) => {
      analyticsCache[product.productId] = product;
    });
  }

  function analyticsCacheGet(productId) {
    return productId ? analyticsCache[productId] : analyticsCache;
  }

  async function fetch(data) {
    try {
      const response = await $.ajax({
        url: '/analytics',
        data: JSON.stringify(data),
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
      });
      analyticsCacheAdd(response.productInformation);
      return response;
    } catch (e) {
      App.sendErrorToRaygun(e);
    }
    return {};
  }

  function getListName($elem) {
    const GENERIC_LIST_NAME = ua ? ua.listName : '';
    if (!($elem instanceof window.jQuery)) {
      return GENERIC_LIST_NAME;
    }

    const $productGroupModule = $elem.closest('[data-webpack-component="productGroupModule"]');
    if ($productGroupModule.length) {
      return `${ua.listName} - Product Group Module - ${$productGroupModule.attr('data-slug')}`;
    }

    const isRelatedProducts = $elem.closest('[data-tracking-id="related-products"]').length;
    if (isRelatedProducts) {
      return 'Related Products Product Page';
    }

    return GENERIC_LIST_NAME;
  }

  function getListPosition($element) {
    // for new product boxes
    const listPosition = $($element).closest('article').parent()
      .find('[data-product-box]')
      .index($element) + 1;
    if (listPosition > 0) {
      return listPosition;
    }
    // for old product boxes
    return $($element).closest('article').parent()
      .find('[data-legacy-product-box]')
      .index($element) + 1;
  }

  function getPackageSKU(productId, lensPackageSKU) {
    if (lensPackageSKU) {
      return lensPackageSKU === -1 ? 'N/A' : lensPackageSKU;
    }
    return productId;
  }

  function stripTags(content) {
    const doc = new DOMParser().parseFromString(content, 'text/html');
    return doc.body.textContent || '';
  }

  function getRibbon(product, defaultValue) {
    let ribbon = defaultValue || 'no ribbon';
    if (product.ribbon) {
      const ribbonText = typeof product.ribbon?.text === 'string' ? product.ribbon.text : product.ribbon;
      ribbon = stripTags(ribbonText);
      if (product.isOnSaleProduct) {
        ribbon = `${ribbon}|Last chance`;
      }
    }
    return ribbon;
  }

  function addCustomProperties(src, dest, propsArray) {
    propsArray.forEach((prop) => {
      if (App.global.objHasProp(src, prop)) {
        /* eslint-disable no-param-reassign */
        if (prop === 'addToCartDate') {
          dest.details = dest.details || src.details || {};
          dest.details[prop] = new Date(src[prop]).toLocaleDateString('sv');
        } else {
          dest[prop] = src[prop];
        }
        /* eslint-enable no-param-reassign */
      }
    });
  }

  function trackInteractionEvent(eventCategory, eventAction, eventLabel, event = 'gaEvent', customerHash = null, callback = null) {
    const data = {
      event,
      eventCategory,
      eventAction,
      eventLabel,
    };

    if (customerHash) {
      data.customerHash = customerHash;
    }

    if (dataLayer) {
      dataLayer.push(data);
    }

    if (callback && typeof callback === 'function') {
      callback();
    }
  }

  function trackNonInteractionEvent(eventCategory, eventAction, eventLabel, customerHash = null, callback = null) {
    trackInteractionEvent(eventCategory, eventAction, eventLabel, 'gaEventNonInteraction', customerHash, callback);
  }

  function trackImpression(event, impressions, pushUndefined = true) {
    if (window.trackingEnabled) {
      if (pushUndefined) {
        dataLayer.push({ impressions: undefined });
      }
      dataLayer.push({
        event,
        impressions,
      });
    }
    return mockTrackingApp;
  }

  function trackImpressionWithoutUndefined(event, impressions) {
    trackImpression(event, impressions, false);
    return mockTrackingApp;
  }

  function trackError(errorMessage) {
    dataLayer.push({
      event: 'error',
      errorMessage,
    });
  }

  function fillProductsFields(data, extraData) {
    const { productInformation } = data;
    const { listPosition, listName: preassignedListName, $elem } = extraData || {};

    const products = !productInformation ? [] : productInformation.map((prodInfo) => {
      if (prodInfo.category !== 'GLASSINDEX' && prodInfo.originalPrice === 0 && !prodInfo.excludedProduct && !prodInfo.isOrderDiscount) {
        return null;
      }

      const product = {
        id: prodInfo.productId,
        groupId: prodInfo.groupId || '',
        name: prodInfo.name,
        category: prodInfo.category,
        categoryNameId: prodInfo.categoryNameId || 'N/A',
        subCategory: prodInfo.subcategory || 'N/A',
        manufacturer: prodInfo.manufacturer || 'N/A',
        availability: prodInfo.stockState || 'N/A',
        price: Math.round((prodInfo.price / ua.VAT) * 100) / 100,
        quantity: prodInfo.inCartQuantity || 1,
        packageSKU: getPackageSKU(prodInfo.productId),
        ribbon: TrackApp.getRibbon(prodInfo),
        lensesUnitSize: prodInfo.size || 'N/A',
        listName: preassignedListName || getListName(extraData && $elem),
        details: prodInfo.details || {},
      };

      if (ua.thanks) {
        product.priceFull = Math.round((prodInfo.originalPrice / ua.VAT) * 100) / 100;
        product.priceFullSEK = Math.round((prodInfo.originalPriceSEK / ua.VAT) * 100) / 100;
        if (App.global.objHasProp(prodInfo, 'addToCartDate')) {
          addCustomProperties(prodInfo, product, ['addToCartDate']);
        }
      }

      if (prodInfo.category === 'FRAME') {
        product.details.frame = {
          lens: {
            coating: prodInfo.frameProduct.lensCoating || 'Not selected',
            usage: prodInfo.frameProduct.lensUsage || 'Not selected',
            thickness: prodInfo.frameProduct.lensThickness || 'Not selected',
            type: prodInfo.frameProduct.lensType || 'Not selected',
          },
          gender: prodInfo.productGender || 'N/A',
          shape: prodInfo.productShape || 'N/A',
          type: prodInfo.frameProduct.type || 'N/A',
          material: prodInfo.frameProduct.material || 'N/A',
          style: prodInfo.frameProduct.style || 'N/A',
          colour: prodInfo.frameProduct.colour || 'N/A',
          priceGroup: Math.round(prodInfo.price) || 'N/A',
          size: prodInfo.frameProduct.size || 'N/A',
        };
      } else if (prodInfo.category === 'LENS') {
        product.packageSKU = getPackageSKU(prodInfo.productId, prodInfo.packageSKU);
      } else if (prodInfo.isReadingGlasses === true) {
        const { frameProduct } = prodInfo;
        if (frameProduct && frameProduct.power) {
          product.details.power = frameProduct.power;
        }
      }

      if (extraData && typeof listPosition !== 'undefined') {
        product.listPosition = listPosition;
      }

      return product;
    });

    return products.filter((p) => p !== null);
  }

  window.TrackApp = {
    ...TrackApp,
    analyticsCacheAdd,
    analyticsCacheGet,
    addCustomProperties,
    fetch,
    fillProductsFields,
    getListName,
    getListPosition,
    getPackageSKU,
    getRibbon,
    trackError,
    trackInteraction: trackInteractionEvent,
    trackNonInteractionEvent,
    trackImpression,
    trackImpressionWithoutUndefined,
    disabled: !window.trackingEnabled,
  };
})();
